import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../lib/preact-pure-component'
import { Lottie } from '../../lottie'
import classNames from 'classnames'
interface Props {
  active: boolean
  preload: boolean
  location?: string
}

export class Map extends PureComponent<Props, {}> {
  getData = (location?: string) => {
    if (location) {
      return require(`./locations/${location}.json`)
    }
  }

  render() {
    const { preload, active, location, locationText } = this.props
    const mapClasses = classNames(style.map, {
      [style.tilGamvik]: location === 'tilgamvik',
      [style.svalbard]: location === 'svalbard'
    })
    const renderLine = location !== 'tilgamvik' && location !== 'svalbard'

    const data = this.getData(location)
    return (
      <div className={style.wrapper}>
        {preload || active ? (
          <div className={mapClasses}>
            <Lottie animationData={data} play={active} />
            {renderLine && [<div className={style.line} />, <div className={style.mapText}>{locationText}</div>]}
          </div>
        ) : (
          <div className={style.map} />
        )}
      </div>
    )
  }
}
